import * as sessionActions from "../../actions/sessionActions";
import AlertModal from "../AlertModal";
import Loader from "../Loader";
import PropTypes from "prop-types";
import QueryString from "qs";
import React, { PureComponent } from "react";
import {
    Col,
    Grid,
    Row,
} from "react-bootstrap";
import { connect } from "react-redux";

const strings = {
    errorModalTitle: "Login Error",
    genericError: "We couldn't verify your account. Please try again.",
};

class LoginAcsPage extends PureComponent {
    static propTypes = {
        storeAndSignIn: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        loading: false,
        errorMessage: "",
    };

    componentDidMount() {
        const query = window.location.search.substring(1);
        const params = QueryString.parse(query);

        if (!params.accessToken) {
            this.setState({errorMessage: strings.genericError})
            return;
        }

        this.props.storeAndSignIn(
            {
                accessToken: params.accessToken,
                expiresIn: parseInt(params.expiresIn),
                refreshToken: params.refreshToken,
            }
        );

        this.props.history.push("/");
    }

    _handleErrorModalClose = () => {
        this.props.history.push("/login");
    }

    render() {
        return (
            <>   
                <Grid>
                    <Row>
                        <Col md={12}>
                            <Loader />
                        </Col>
                    </Row>
                </Grid>
                <AlertModal show={!!this.state.errorMessage} alertMessage={this.state.errorMessage} handleClose={this._handleErrorModalClose}/>
            </>
        )
    }
}

export default connect(null, sessionActions)(LoginAcsPage);
